module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"or":"または","continue_with_google":"Googleで続ける","google_exp":"Googleはサインインのみに使用されます。ユーザーの役割と権限は変更されません。"}}')
  delete Component.options._Ctor
}
